"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ZipCode;
var _react = _interopRequireWildcard(require("react"));
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _Col = _interopRequireDefault(require("react-bootstrap/Col"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
var _axios = _interopRequireDefault(require("axios"));
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _reactRedux = require("react-redux");
var _actions = require("../store/actions");
var _usersession = require("usersession");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { useRatesContext } from "../context/ratesContext";

const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop, {
  behavior: "smooth"
});
// General scroll to element function

function ZipCode() {
  // const {
  //   state,
  //   ShowButtons,
  //   zipCodeUpdate,
  //   stateCountyUpdate,
  //   countryStateUpdate,
  // } = useRatesContext();
  const dispatch = (0, _reactRedux.useDispatch)();
  const zipCodeRedux = (0, _reactRedux.useSelector)(state => state.nameReducer.zipCode);
  const [zipCode, setZipCode] = (0, _react.useState)("");
  const [zipcodeError, setZipCodeError] = (0, _react.useState)("");
  // const zipCodeRedux = state.zipCode;

  const userSession = new _usersession.UserSession();
  let stateList = JSON.parse(userSession.getStateList());
  let propertyState = "";
  const myRefZip = (0, _react.useRef)(null);
  function updateZipCode(propZipCode) {
    setZipCode(propZipCode);
    if (propZipCode.length == 5) {
      _axios.default.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + propZipCode, {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        propertyState = stateList.filter(state => state.code == response.data.state);
        if (!propertyState || !propertyState.length) {
          document.getElementById("next-button").disabled = true;
          // zipCodeUpdate("");
          dispatch((0, _actions.zipCodeUpdate)(""));
          setZipCodeError("We are not accepting applications for the state of ".concat(response.data.state));
        } else {
          userSession.setPropertyZipCode(propZipCode);
          userSession.setPropertyState(response.data.state);
          userSession.setPropertyCounty(response.data.counties[0].code);
          // zipCodeUpdate(propZipCode);
          dispatch((0, _actions.zipCodeUpdate)(propZipCode));
          // stateCountyUpdate(response.data.counties[0].code);
          dispatch((0, _actions.stateCountyUpdate)(response.data.counties[0].code));
          // countryStateUpdate(response.data.state);
          dispatch((0, _actions.countryStateUpdate)(response.data.state));
          document.getElementById("next-button").disabled = false;
        }
      }).catch(e => {
        setZipCodeError(e.response.data.error);
      });
    }
    if (propZipCode.length < 5) {
      // dont disabled the Next button if zipcode field is empty
      document.getElementById("next-button").disabled = false;
      // zipCodeUpdate("");
      dispatch((0, _actions.zipCodeUpdate)(""));
      userSession.setPropertyZipCode("");
      setZipCodeError("");
    }
  }
  (0, _react.useEffect)(() => {
    //This function scroll the slider into view
    !localStorage.getItem("doNotScroll") && scrollToRef(myRefZip);
  }, []);
  (0, _react.useEffect)(() => {
    setZipCode(zipCodeRedux);
    dispatch((0, _actions.ShowButtons)(false));
    // ShowButtons(false)
    if (zipCode.length == 5) {
      userSession.setPropertyZipCode(zipCode);
      _axios.default.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + zipCode, "", {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        userSession.setPropertyCounty(response.data.counties[0].code);
        dispatch((0, _actions.stateCountyUpdate)(response.data.counties[0].code));
        userSession.setPropertyState(response.data.state);
        // countryStateUpdate(response.data.state);
        dispatch((0, _actions.countryStateUpdate)(response.data.state));
      });
    }
    if (!zipCode || zipCode.length < 5) {
      // dont disabled the Next button if zipcode field is empty
      document.getElementById("next-button").disabled = false;
      setZipCodeError("");
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: "d-flex justify-content-center pt-1"
  }, /*#__PURE__*/_react.default.createElement(_Col.default, {
    lg: 12
  }, /*#__PURE__*/_react.default.createElement("h2", null, "What is the property zip code? (Skip Next if not Known)")), /*#__PURE__*/_react.default.createElement(_Col.default, {
    md: 10
  }, zipcodeError ? /*#__PURE__*/_react.default.createElement("p", {
    className: "text-danger mb-0"
  }, zipcodeError) : null), /*#__PURE__*/_react.default.createElement(_Form.default.Group, {
    as: _Col.default,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Label, {
    className: "visually-hidden"
  }, "Zipcode"), /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    ref: myRefZip,
    className: "form-control",
    placeholder: "Property Zip Code",
    format: "#####",
    value: zipCode,
    displayType: "input",
    thousandSeparator: false,
    fixedDecimalScale: true,
    onValueChange: values => {
      updateZipCode(values.value);
    }
  }))));
}